import apiClient from "./client";

export async function getDashboard() {
  const res = await apiClient.get("/api/dashboard");
  if (res.status === 401) {
    localStorage.removeItem("token");
    throw Object.assign(new Error("Unauthorized"), { status: 401 });
  }
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function getBoard(companySlug, boardSlug, boardAccessToken) {
  const res = await apiClient.get(`/api/board/${companySlug}/${boardSlug}`, { token: boardAccessToken });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function checkBoardAccess(companySlug, boardSlug) {
  const res = await apiClient.post("/api/board/access", { board_slug: boardSlug, company_slug: companySlug });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function checkBoardPassword(companySlug, boardSlug, password) {
  const res = await apiClient.post("/api/board/password", { board_slug: boardSlug, company_slug: companySlug, password }, { auth: false });
  const data = await res.json();
  return { ok: res.ok, data };
}

export async function createBoard(companySlug) {
  const res = await apiClient.post("/api/create-board", { companySlug });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function updateBoardStatus(boardId, status) {
  const res = await apiClient.post("/api/board/update-status", { board_id: boardId, status });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || "Помилка оновлення статусу борда");
  return data;
}

export async function getBoardPasswords(boardId) {
  const res = await apiClient.post("/api/get-board-passwords", { board_id: boardId });
  const data = await res.json();
  if (!res.ok) throw new Error("Не вдалося завантажити паролі");
  return data;
}

export async function updateBoardPasswords(boardId, managerPassword, viewerPassword, statusCommentsEnabled) {
  const res = await apiClient.post("/api/update-board-passwords", {
    board_id: boardId,
    manager_password: managerPassword,
    viewer_password: viewerPassword,
    status_comments_enabled: statusCommentsEnabled,
  });
  if (!res.ok) throw new Error("Помилка оновлення паролів");
  return res.json();
}

export async function upgradePlanAndCreateBoard(companySlug, newPlanLimit) {
  const res = await apiClient.post("/api/upgrade-plan-and-create-board", { companySlug, newPlanLimit });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Помилка запиту");
  return data;
}

export async function upgradePlanAndUpdateBoardStatus(companySlug, newPlanLimit, boardId) {
  const res = await apiClient.post("/api/upgrade-plan-and-update-board-status", {
    companySlug,
    newPlanLimit,
    boardId,
    status: "active",
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || "Помилка запиту");
  return data;
}
